
import { ChartActions } from '@/store/actions/charts';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Plotly } from 'vue-plotly';
import BarChartER from '@/components/DataTab/Charts/ChartComponents/BarChartER.vue';
import { ChartReturnType, PlotlyTraceType } from '@/types';
import { txtwrapper } from '@/helpers/txtwrapper';
import { colors } from '@/assets/colors/colors';

@Component({ components: { Plotly, BarChartER } })
export default class Plot27 extends Vue {
  mounted() {
    this.$store.dispatch(ChartActions.CHART_REQUEST, {
      chartId: this.selectedChart,
      basinId: this.selectedArea.id,
    });
  }

  xLabels = [
    'Fish-Cold Water',
    'Fish-Warm Water',
    'Fish- Plains',
    'Wetlands/ Riparian',
    'Boating',
    'ISFs',
  ];

  selectedNode = '';

  get selectItems() {
    const array: string[] = [];
    this.$store.getters.data.forEach((obj: ChartReturnType) => {
      if (obj.node && !array.includes(obj.node)) {
        array.push(obj.node);
      }
    });
    return array;
  }

  get chartData() {
    const initialData = [
      {
        x: this.xLabels,
        y: [],
        name: this.$t(`data.chartTables.${this.selectedChart}.head`),
        type: 'bar',
        marker: {
          color: colors.mediumBlue,
        },
      },
    ];

    this.$store.getters.data.forEach((obj: ChartReturnType) => {
      initialData.forEach((object: PlotlyTraceType) => {
        if (obj.node === this.selectedNode) {
          object.y.push(obj.fish_coldwater as number);
          object.y.push(obj.fish_warmwater as number);
          object.y.push(obj.fish_plain as number);
          object.y.push(obj.wetlands as number);
          object.y.push(obj.boating as number);
          object.y.push(obj.isfs as number);
        }
      });
    });

    return txtwrapper(initialData);
  }

  get scenarioList() {
    return this.$store.getters.selectedScenarioList;
  }

  get selectedArea() {
    return this.$store.getters.selectedArea;
  }

  get selectedChart() {
    return this.$store.getters.selectedChart;
  }

  @Watch('selectItems')
  watchItems(val: string[]) {
    this.selectedNode = val[0];
  }
}
